import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle3 from "../../randing/RandingStyle3";

function Randing012({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="1"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/012/2024111301.gif`}
      numberColor="#3f8c58"
      qOptionColor="green"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/009/02_241111_01_btn_send.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/dlatl.jpg`}
    />
  );
}

export default Randing012;
